import { Injectable } from '@angular/core';

@Injectable()
export abstract class ProjectMapperStrategy<Payload = unknown, P = unknown> {
  abstract mapToProject(apiProject: Payload, apiConfig?: unknown): P;
}
